import Vue from "vue";
import store from '../store';
import VueRouter from "vue-router";
import staticRoute from "./static-route"
import { defineAsyncComponent } from "vue";
import NProgress from 'nprogress';
import { getToken } from "@/utils/auth";

NProgress.configure({ showSpinner: false });

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

let isHyzx = false

const routes = [
    ...staticRoute,
    {
        path: "/",
        name: "layout",
        component: defineAsyncComponent(() => import("@/views/layout/index.vue")),
        redirect: 'home/index',
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect')
            },
            {
                path: "/hqzx/industryInfoDetail",
                name: "industryInfoDetail",
                component: defineAsyncComponent(() => import("@/views/hqzx/industryInfoDetail.vue")),
                meta: { title: '行业资讯-详情', activeMenu: `/hqzx/industryInfoList/pathId` }
                // meta: { title: '行业资讯-详情', activeMenu: "/hqzx/index" }
            },
            {
                path: "/jydt/dealDetail",
                name: "dealDetail",
                component: defineAsyncComponent(() => import("@/views/jydt/dealDetail.vue")),
                meta: { title: '交易大厅-详情', activeMenu: '/jydt/index' }
            },
            {
                path: "/jydt/dealOrderPage",
                name: "dealOrderPage",
                component: defineAsyncComponent(() => import("@/views/jydt/dealOrderPage.vue")),
                meta: { title: '交易大厅-摘牌', activeMenu: '/jydt/index' }
            },
            {
                path: "/gyljr/financeDetail",
                name: "financeDetail",
                component: defineAsyncComponent(() => import("@/views/gyljr/financeDetail.vue")),
                meta: { title: '供应链服务-详情', activeMenu: '/gyljr/index' }
            },
            {
                path: "/ptxy/collegeDetail",
                name: "collegeDetail",
                component: defineAsyncComponent(() => import("@/views/ptxy/collegeDetail.vue")),
                meta: { title: '平台学院-详情', activeMenu: `/ptxy/index` }
                // meta: { title: '平台学院-详情', activeMenu: "/ptxy/index" }
            },
            {
                path: "/ptxy/collegeMoreList",
                name: "collegeMoreList",
                component: defineAsyncComponent(() => import("@/views/ptxy/collegeMoreList.vue")),
                meta: { title: '平台学院-列表', activeMenu: `/ptxy/index` }
            },
            {
                path: "/cjgs/index",
                name: "cjgsIndex",
                component: defineAsyncComponent(() => import("@/views/cjgs/index.vue")),
                meta: { title: '成交公示', activeMenu: '/home/index' }
            },
            {
                path: "/message/index",
                name: "message",
                component: defineAsyncComponent(() => import("@/views/message/index.vue"))
            },
            {
                path: "/message/detail",
                name: "messageDetail",
                component: defineAsyncComponent(() => import("@/views/message/detail.vue"))
            },
            {
                path: "/safeguardSupply/index",
                name: "safeguardSupplyIndex",
                component: defineAsyncComponent(() => import("@/views/bgzq/index.vue")),
                meta: { title: '保供专区', activeMenu: '/home/index' }
            },
            {
                path: "/safeguardSupply/detail",
                name: "safeguardSupplyDetail",
                component: defineAsyncComponent(() => import("@/views/bgzq/detail.vue")),
                meta: { title: '保供专区详情', activeMenu: '/home/index' }
            },
            {
                path: "/insuranceSupermarket/index",
                name: "insuranceSupermarketIndex",
                component: defineAsyncComponent(() => import("@/views/bxcs/index.vue")),
                meta: { title: '保险超市', activeMenu: '/home/index' }
            },
            {
                path: "/insuranceSupermarket/detail",
                name: "insuranceSupermarketDetail",
                component: defineAsyncComponent(() => import("@/views/bxcs/detail.vue")),
                meta: { title: '保险超市详情', activeMenu: '/home/index' }
            },
            {
                path: "/unitPurchase/index",
                name: "unitPurchaseIndex",
                component: defineAsyncComponent(() => import("@/views/dwjc/index.vue")),
                meta: { title: '单位集采', activeMenu: '/home/index' }
            },
            {
                path: "/unitPurchase/detail",
                name: "unitPurchaseDetail",
                component: defineAsyncComponent(() => import("@/views/dwjc/detail.vue")),
                meta: { title: '单位集采详情', activeMenu: '/home/index' }
            },
            {
                path: "/pastureAlliance/index",
                name: "pastureAllianceIndex",
                component: defineAsyncComponent(() => import("@/views/xbmclm/index.vue")),
                meta: { title: '西北牧草联盟', activeMenu: '/home/index' }
            },
            {
                path: "/hq/index",
                name: "marketIndex",
                component: defineAsyncComponent(() => import("@/views/hq/index.vue")),
                meta: { title: '行情', activeMenu: '/home/index' }
            },
        ]
    },
];
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
store.dispatch('GenerateRoutes').then(accessRoutes => {
    addRouteFunction(accessRoutes, "layout");
});
// store.dispatch('GetHyzxRoutes').then(accessRoutes => {
//     addRouteFunction(accessRoutes, "hyzx");
// });
router.beforeEach(async (to, from, next) => {

    router.routes = routes;
    window.scrollTo(0, 0);
    NProgress.start();
    if (to.path.startsWith('/hyzx') && !isHyzx) {
        const accessRoutes = await store.dispatch('GetHyzxRoutes');
        addRouteFunction(accessRoutes, "hyzx");
        if (accessRoutes[0].children) {
            next({path: accessRoutes[0].children[0].path});
        } else {
            next({path: accessRoutes[0].path})
        }
        isHyzx = true
    } else {
        NProgress.done()
        next()
    }
});
const addRouteFunction = (routes, parentRoutes) => {
    routes.forEach(routeItem => {
        router.addRoute(parentRoutes, {
            path: routeItem.path,
            component: loadView(routeItem.component),
            meta: {
                title: routeItem.menuName
            }
        });
        if (routeItem.children) {
            addRouteFunction(routeItem.children, parentRoutes)
        }
    })
};
const loadView = (view) => {
    if (process.env.NODE_ENV === 'development') {
        return (resolve) => require([`@/views/${view}`], resolve);
    } else {
        // 使用 import 实现生产环境的路由懒加载
        return () => import(`@/views/${view}`);
    }
};
export default router;
